// getFilterGroupMap.js
'use strict';
import createCachedSelector from '../resource/createCachedSelector.js';

import getRemoteConfigData from '../selector/getRemoteConfigData.js';

/**
 * Select filter group map
 * @kind selector
 * @param {Immutable.Map} state - root state.
 * @param {string} filterType - filter type.
 * @return {object} Return filter group map.
 */
const getFilterGroupMap = createCachedSelector(
  state => state.get('remoteConfig'),
  (state, filterType = 'v1') =>
    getRemoteConfigData(
      state,
      `LIVESTREAM_FEED_FILTER_${filterType.toUpperCase()}_LIST`
    ),
  (remoteConfigMap, filterGroups) => {
    if (!filterGroups) return {};

    return filterGroups.reduce((acc, filterGroup) => {
      const filters = remoteConfigMap.get(filterGroup)?.split(' ') || [];

      return filters.length > 0 ? { ...acc, [filterGroup]: filters } : acc;
    }, {});
  }
)((state, filterType) => `${filterType}`);

export default getFilterGroupMap;
